import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const modalWidth = 300;

export const Container = styled.div(({ theme }) => ({
    borderRadius: theme.spacing.large,
    background: theme.colors[theme.colorMode].background_Primary,
    minWidth: `${modalWidth}px`,
    position: "relative",
    padding: theme.spacing.large,
    paddingTop: theme.spacing.x12,
}));

export const StyledCloseIcon = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
    zIndex: 1,
}));

export const StyledText = styled(Text)(({ theme }) => ({
    maxWidth: "221px",
    marginBottom: theme.spacing.xxSmall,
}));

export const ButtonWrapper = styled.div(() => ({
    width: "50%",
}));

export const ContentRow = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xxSmall,
}));

export const ButtonRow = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.medium,
    gap: theme.spacing.small,
}));
